import React from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Button, Flex, Spacer, Text } from '@oliasoft-open-source/react-ui-library';
import { FeatureFlags } from '@oliasoft/feature-flags';
import { RiskType } from 'src/enums/project-modifiers';
import emptyIcon from 'src/assets/empty.svg';
import translations from 'src/internationalisation/translation-map.json';

export const NoRisks = ({ onClickAdd, isPageDisabled }) => {
  const { t } = useTranslation();
  const isModifierForCostActive = FeatureFlags.isActive('Project Modifier For Cost');

  return (
    <Flex alignItems="center" justifyContent="center" direction="column" height="100%">
      <Icon icon={emptyIcon} />
      <Spacer height="var(--padding-xs)" />
      <Text faint>{t(translations.risks_noRisksHaveBeenAddedYet)}</Text>
      <Spacer height="var(--padding-xs)" />
      {!isModifierForCostActive && (
        <Button
          name="addRisk"
          label={t(translations.risks_addRisk)}
          onClick={() => onClickAdd(RiskType.TIME)}
          colored
          disabled={isPageDisabled}
        />
      )}
    </Flex>
  );
};
